/**
 * The fallback for a column type the web registry does not know (B5 §9 R1).
 *
 * It renders the shared registry's `toText` read-only and never loses data: a board carrying a
 * `timeline`, a `location` or a monday app column still opens, and the cells round-trip.
 */
import { findColumnType } from '@elizmonday/shared';
import { CellText } from '../primitives';
import { defineColumnUi } from '../types';

export const unsupportedColumnUi = defineColumnUi<unknown, Record<string, unknown>>({
  type: 'unsupported',
  icon: 'columnGeneric',
  gallery: { group: 'advanced', keywords: [] },
  /** P-022: the registry default. ASSUMED — no `width: null` column of this type is measured. */
  defaultWidth: 140,
  align: 'left',
  groupable: false,

  Cell: ({ value, settings, column, context }) => {
    const shared = findColumnType(column.type);
    const text = shared ? (shared.toText(value, settings) ?? '') : stringify(value);
    return <CellText text={text} align="left" search={context.search} />;
  },

  fromClipboard() {
    throw new Error('read-only');
  },
  toClipboard(value) {
    return stringify(value);
  },
  bucketsOf() {
    return [];
  },
});

function stringify(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  return JSON.stringify(value);
}
